import React from 'react';
import Icon from '../../../components/AppIcon';

const TransactionStatusCard = ({ status, transactionData }) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'verified':
        return {
          icon: 'CheckCircle',
          title: 'Pago Verificado',
          subtitle: 'Tu transacción ha sido confirmada exitosamente',
          bgColor: 'bg-success/10',
          borderColor: 'border-success/30',
          iconColor: 'text-success',
          titleColor: 'text-success'
        };
      case 'pending':
        return {
          icon: 'Clock',
          title: 'Pago Pendiente',
          subtitle: 'Estamos verificando tu transacción',
          bgColor: 'bg-warning/10',
          borderColor: 'border-warning/30',
          iconColor: 'text-warning',
          titleColor: 'text-warning'
        };
      case 'failed':
        return {
          icon: 'XCircle',
          title: 'Pago Fallido',
          subtitle: 'Hubo un problema con tu transacción',
          bgColor: 'bg-error/10',
          borderColor: 'border-error/30',
          iconColor: 'text-error',
          titleColor: 'text-error'
        };
      default:
        return {
          icon: 'Info',
          title: 'Estado Desconocido',
          subtitle: 'Contacta con soporte para más información',
          bgColor: 'bg-muted/10',
          borderColor: 'border-border',
          iconColor: 'text-muted-foreground',
          titleColor: 'text-muted-foreground'
        };
    }
  };

  const config = getStatusConfig();

  return (
    <div className={`${config?.bgColor} ${config?.borderColor} border-2 rounded-2xl p-8 text-center shadow-luxury`}>
      <div className="flex justify-center mb-6">
        <div className={`w-20 h-20 rounded-full ${config?.bgColor} flex items-center justify-center border ${config?.borderColor}`}>
          <Icon 
            name={config?.icon} 
            size={40} 
            className={config?.iconColor}
          />
        </div>
      </div>
      <h2 className={`text-3xl font-heading font-bold ${config?.titleColor} mb-2`}>
        {config?.title}
      </h2>
      <p className="text-lg text-gray-800 font-body mb-6"> {/* Cambiado aquí */}
        {config?.subtitle}
      </p>
      {status === 'pending' && (
        <div className="bg-card rounded-lg p-4 border border-border">
          <div className="flex items-center justify-center space-x-2 mb-2">
            <Icon name="Clock" size={16} className="text-warning" />
            <span className="text-sm font-medium text-gray-800"> {/* Cambiado aquí */}
              Tiempo estimado de verificación
            </span>
          </div>
          <p className="text-2xl font-mono font-bold text-warning">15-30 minutos</p>
          <p className="text-xs text-gray-800 mt-1"> {/* Cambiado aquí */}
            Durante horario bancario
          </p>
        </div>
      )}
      {status === 'verified' && transactionData?.ticketNumbers && (
        <div className="bg-gradient-to-r from-secondary/10 to-golden/10 rounded-lg p-4 border border-secondary/30">
          <div className="flex items-center justify-center space-x-2 mb-3">
            <Icon name="Ticket" size={16} className="text-secondary" />
            <span className="text-sm font-medium text-gray-800"> {/* Cambiado aquí */}
              Boletos Asignados
            </span>
          </div>
          <div className="flex flex-wrap justify-center gap-2">
            {transactionData?.ticketNumbers?.map((ticket, index) => (
              <span 
                key={index}
                className="bg-secondary text-secondary-foreground px-3 py-1 rounded-lg font-mono font-bold text-sm"
              >
                {ticket}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TransactionStatusCard;